import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Typography from 'material-ui/Typography'
import ListSubheader from 'material-ui/List/ListSubheader'
import List, {ListItem, ListItemIcon, ListItemText} from 'material-ui/List'
import TodayIcon from 'material-ui-icons/Today'
import LocationOnIcon from 'material-ui-icons/LocationOn'
import ExpandLess from 'material-ui-icons/ExpandLess'
import ExpandMore from 'material-ui-icons/ExpandMore'
import CommentIcon from 'material-ui-icons/Comment'
import CreditCardIcon from 'material-ui-icons/CreditCard'
import Collapse from 'material-ui/transitions/Collapse'
import TextField from 'material-ui/TextField'

import {review as text} from '../text'
import LoadingButton from '../../../common/components/LoadingButton'

import {reviewStyles as styles} from '../styles'

class Review extends React.Component {

  state = {
    open: false,
  }

  handleClick = () => {
    this.setState({open: !this.state.open})
  }

  renderCardDigits = c => (
    `···· ${c.LastDigits} (${c.Type})`
  )

  render() {
    const {classes, address, date, card, comment, isConfirming} = this.props
    return (
      <div>
        <Title classes={classes} text={text.almostDone}/>
        <List className={classes.list}>
          <ListSubheader>{text.details}</ListSubheader>
          <ListItem button onClick={() => this.props.setStep(3)}>
            <ListItemIcon><LocationOnIcon/></ListItemIcon>
            <ListItemText inset primary={address === '' ? text.addYourAddress : address}/>
          </ListItem>
          <ListItem button onClick={() => this.props.setStep(2)}>
            <ListItemIcon><TodayIcon/></ListItemIcon>
            <ListItemText inset primary={date.format('ddd D MMM HH:mm')}/>
          </ListItem>
          <ListItem button onClick={this.handleClick}>
            <ListItemIcon><CommentIcon/></ListItemIcon>
            <ListItemText inset primary={text.comments}/>
            {this.state.open ? <ExpandLess/> : <ExpandMore/>}
          </ListItem>
          <Collapse component="li" in={this.state.open} timeout="auto" unmountOnExit>
            <TextField
              id="textarea"
              placeholder="..."
              multiline
              margin="none"
              fullWidth
              value={comment}
              onChange={e => this.props.setComment(e.target.value)}
            />
          </Collapse>
          <ListSubheader>{text.payment}</ListSubheader>
          <ListItem button onClick={() => this.props.setStep(5)}>
            <ListItemIcon>
              <CreditCardIcon/>
            </ListItemIcon>
            <ListItemText inset primary={card === null ? text.addYourCreditCard : this.renderCardDigits(card)}/>
          </ListItem>
        </List>
        <Actions classes={classes} isLoading={isConfirming} isDisabled={card === null} onClick={this.props.confirm}/>
      </div>
    )
  }

  static propTypes = {
    setStep: PropTypes.func.isRequired,
    address: PropTypes.string,
    date: PropTypes.object,
    card: PropTypes.object,
    comment: PropTypes.string,
    setComment: PropTypes.func.isRequired,
    confirm: PropTypes.func.isRequired,
    isConfirming: PropTypes.bool,
  }
}

const Title = ({classes, text}) => (
  <div>
    <Typography variant="title" className={classes.dialogTitle}>{text}</Typography>
  </div>
)

const Actions = ({classes, isLoading, isDisabled, onClick}) => (
  <div className={classes.dialogActions}>
    <LoadingButton
      variant="raised"
      color="primary"
      onClick={onClick}
      disabled={isDisabled}
      isLoading={isLoading}
    >
      {text.confirm}
    </LoadingButton>
    <Typography className={classes.viewPrices}>{text.viewPrices}</Typography>
  </div>
)

export default withStyles(styles, {withTheme: true})(Review)



// WEBPACK FOOTER //
// ./src/sections/rent/components/review.js